/* eslint-disable */
<template>
    <v-dialog
      :value="dialogFlag"
      @input="$emit('mychange', $event)"
      @click:outside="closeDialog()"
      max-width="800px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-4 text-center"
          color="rgba(0, 189, 242, 1)"
          dark><span class="text-center">シフト入力</span></v-toolbar>


        <v-card-text>

          <v-container class="mt-3">
          <v-row class="d-flex justify-space-between">
              <v-col cols="2" class="text-left">スタッフ名</v-col>
              <v-col cols="10" class="text-left">
                  <h3>{{l_staff_name}}</h3>
              </v-col>
          </v-row>

    <v-row v-for="(v,index) in oya_eigyoubi_staff" :key="v.id" justify="start">
        <v-col cols="2" class="text-left mymidasi" align-self="center">
            <!-- {{(v.date+'').slice(0,4)}}年 --> {{(v.date+'').slice(5,7)}}月{{(v.date+'').slice(8,10)}}日({{v.dayofweek}})
        </v-col>
        <v-col cols="0" class="mycheck text-left" align-self="center">
            <v-checkbox class="d-flex align-start"
              v-model="v.first_check"
            ></v-checkbox>
        </v-col>
        <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="center">

                    <v-select dense
                        :items="first_start"
                        v-model="v.first_start"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="isDisabled(v, 'first')"
                        :filled="isDisabled(v, 'first')"
                        @change="change_shift(index, 'first_end', v.first_start)"
                    ></v-select>


                    <span style="line-height: 2.2em; margin: 0 2px;">～</span>

                    <v-select dense
                        :items="first_end"
                        v-model="v.first_end"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="isDisabled(v, 'first')"
                        :filled="isDisabled(v, 'first')"
                        @change="change_shift(index, 'first_start', v.first_end)"
                    ></v-select>

        </v-col>
        <v-col cols="0" class="mycheck text-left" align-self="start">
            <v-checkbox class="d-flex align-start"
              v-model="v.second_check"
            ></v-checkbox>
        </v-col>
        <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="start">

                    <v-select dense
                        :items="second_start"
                        v-model="v.second_start"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="isDisabled(v, 'second')"
                        :filled="isDisabled(v, 'second')"
                        @change="change_shift(index, 'second_end', v.second_start)"
                    ></v-select>


                    <span style="line-height: 2.2em; margin: 0 2px;">～</span>

                    <v-select dense
                        :items="second_end"
                        v-model="v.second_end"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="isDisabled(v, 'second')"
                        :filled="isDisabled(v, 'second')"
                        @change="change_shift(index, 'second_start', v.second_end)"
                    ></v-select>

        </v-col>

    </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click.stop.prevent="closeDialog()">キャンセル</v-btn>
          <v-btn dark
            color="rgba(0, 189, 242, 1)"
            @click.stop.prevent="touroku()">登録</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>
/* eslint-disable */


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */


export default {
    props: {
      dialogFlag: Boolean,
      data: Object,
      oya_eigyoubi_staff: Array,
      staff_id: Number,
      staff_name: String,
    },
    // datas
    data() {
            return {

        l_staff_id: this.staff_id,
        l_staff_name: this.staff_name,
        first_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        first_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        // ベース（スタッフ個別）曜日別: staffs.eigyoubi JSON
        baseStaffByDow: {},
        // 初期スナップショット（フォールバック）
        initialSnapshot: [],
            }
    },
    created(){
        console.log('%ccreated: DialogEigyoubiStaff.vue', mycolor.purple);
        // 初期スナップショット
        try{ this.initialSnapshot = JSON.parse(JSON.stringify(this.oya_eigyoubi_staff || [])); }catch(e){ this.initialSnapshot = []; }
        // スタッフ個別の基本シフト
        if(this.l_staff_id){
            axios.get('/get_staff_by_id/'+this.l_staff_id).then(res=>{
                const st = res.data;
                const map={};
                if(st && st.eigyoubi){
                    if(Array.isArray(st.eigyoubi)){
                        const dowArr=['月','火','水','木','金','土','日'];
                        st.eigyoubi.forEach((o,i)=>{ map[dowArr[i]] = o; });
                    }else{
                        for(const v of Object.values(st.eigyoubi)){
                            if(v && v.dayofweek){ map[v.dayofweek]=v; }
                        }
                    }
                }
                this.baseStaffByDow = map;
            }).catch(()=>{});
        }
    },
    watch: {
        staff_id(){
            console.log('staff_id()');
            this.l_staff_id = this.staff_id;
            // スタッフ変更時にベース再取得
            axios.get('/get_staff_by_id/'+this.l_staff_id).then(res=>{
                const st = res.data; const map={};
                if(st && st.eigyoubi){
                    if(Array.isArray(st.eigyoubi)){
                        const dowArr=['月','火','水','木','金','土','日'];
                        st.eigyoubi.forEach((o,i)=>{ map[dowArr[i]] = o; });
                    }else{
                        for(const v of Object.values(st.eigyoubi)){
                            if(v && v.dayofweek){ map[v.dayofweek]=v; }
                        }
                    }
                }
                this.baseStaffByDow = map;
            }).catch(()=>{});
        },
        staff_name(){
            console.log('staff_name()');
            this.l_staff_name = this.staff_name;
        },
        // 親の配列が更新されたら、月毎営業日（eigyoubi_kobetu 反映済みの first/second_check）に基づいて
        // 非営業の部は空欄化＆編集不可（チェックはfalseのまま）。営業の部で空欄ならスタッフの基本から補完。
        oya_eigyoubi_staff: {
            handler(newVal){
                try{ this.initialSnapshot = JSON.parse(JSON.stringify(newVal || [])); }catch(e){ this.initialSnapshot = []; }
                if(!Array.isArray(newVal)) return;
                const rows = newVal;
                for(let i=0;i<rows.length;i++){
                    const row = rows[i];
                    const dow = row.dayofweek;
                    // 月毎営業日で午前が休みなら空欄
                    if(row.first_check===0 || row.first_check==='0' || row.first_check===false){
                        this.$set(row,'first_check', false);
                        this.$set(row,'first_start','');
                        this.$set(row,'first_end','');
                    }
                    if(row.second_check===0 || row.second_check==='0' || row.second_check===false){
                        this.$set(row,'second_check', false);
                        this.$set(row,'second_start','');
                        this.$set(row,'second_end','');
                    }
                }
            },
            deep: true,
            immediate: true,
        }

    },
    computed: {

    },
    methods: {
        isDisabled(row, part){
          // 月毎営業日のチェック（eigyoubi_kobetu をバックエンドで反映済み）に従って制御
          return (part==='first') ? !row.first_check : !row.second_check;
        },
        change_shift(i, column, v){
          console.log('change_shift()');
          console.log('index: ', i);
          console.log('column: ', column);
          console.log('v: ', v);

          // 時刻の片方が空だったらペアも空にする.
          if(v===''){
              this.oya_eigyoubi_staff[i][column] = '';
          }
        },
        closeDialog(){

            console.log('closeDialog()');
            this.$emit('closeDialogStaff', 'gohenshin');
        },
        touroku(){
            console.log('touroku()');
            console.log('oya_eigyoubi_staff: ', this.oya_eigyoubi_staff);


              axios.post( '/validate_time_with_date_staff', this.oya_eigyoubi_staff)
                .then((res) => {
                  console.group();
                  console.log('%c %s', mycolor.purple, '/validate_time_with_date_staff');
                  console.log(res.data);
                  console.groupEnd();

                  if(res.data===true){
                    console.log('バリデーション OK');
                        this.$emit('tourokuEigyoubiStaff');
                  }else{
                    alert(res.data);
                  }
                })
                .catch(() => {
                  // eslint-disable-next-line
                  console.error();
                });
                return false;

        },
    }, // methods
}
/* eslint-disable */
</script>

<style scoped>
.my_border{
    border: solid 1px #444;
    border-radius: 6px;
    padding: 8px;
}
.blue_border{
    border: solid 1px blue;
}
/deep/ .mycheck{
    display: none !important;
}
.row > div {
    max-height: 60px;
}
.mymidasi{
    height: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
